import React from 'react';

import { Icon } from '../icons';

export const FallIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M28.7534 26.994C28.5978 27.3701 28.3686 27.7228 28.0658 28.0303C28.054 28.0422 28.0422 28.054 28.0303 28.0658C27.4447 28.6425 26.6414 28.9987 25.7549 29C25.7532 29 25.7516 29 25.75 29H25.7494H9.5C7.70507 29 6.25 27.5449 6.25 25.75C6.25 23.9551 7.70507 22.5 9.5 22.5H17.9038L3.9519 8.5481C2.6827 7.27889 2.6827 5.22111 3.9519 3.9519C5.22111 2.6827 7.27889 2.6827 8.5481 3.9519L22.5 17.9038V9.5C22.5 7.70507 23.9551 6.25 25.75 6.25C27.5449 6.25 29 7.70507 29 9.5V25.75C29 26.1907 28.9123 26.6109 28.7534 26.994Z" />
    </svg>
  );
};
